import axios from "axios";
import { clearAuthSession, getAuthToken, getAuthUser } from "./authStorage";
import { showError } from "../utils/ alert";
import { isSalesRole } from "./roleAccess";

// Wajib di-set di .env / .env.production (mis. https://api.arunikamedina.com).
// Kosong hanya masuk akal saat dev lokal dengan "proxy" di package.json.
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL ?? "",
  timeout: 10000,
});

// Otomatis kirim token di setiap request kalau user sudah login
axiosInstance.interceptors.request.use((config) => {
  const token = getAuthToken();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

const FORBIDDEN_DEFAULT_MESSAGE = "Anda tidak memiliki akses untuk tindakan ini.";

/**
 * True kalau error berasal dari respons 403 yang SUDAH ditampilkan pesannya
 * oleh interceptor (hanya untuk role Sales). Dipakai halaman supaya tidak
 * menimpa pesan 403 dengan pesan generik ("Failed to load ...").
 */
export const isForbiddenError = (error: unknown) =>
  Boolean((error as { isForbidden?: boolean } | null)?.isForbidden);

// - 401 (token invalid/expired): otomatis logout & redirect ke halaman login
//   supaya user tidak stuck dengan token basi.
// - 403 untuk Sales (login valid tapi role tidak boleh): tampilkan pesan,
//   TANPA logout. Untuk Admin/Staff interceptor tidak menampilkan apa pun;
//   halaman tetap memakai pesan error-nya sendiri seperti sebelumnya, supaya
//   tidak ada dua popup untuk satu error.
export const handleResponseError = (error: any) => {
  const status = error?.response?.status;

  if (status === 401) {
    clearAuthSession();

    // Hindari redirect loop kalau memang lagi di halaman login
    if (window.location.pathname !== "/login") {
      window.location.href = "/login";
    }
  }

  if (status === 403 && isSalesRole(getAuthUser()?.role)) {
    error.isForbidden = true;
    const message = error.response?.data?.message;
    showError(
      "Akses ditolak",
      typeof message === "string" && message ? message : FORBIDDEN_DEFAULT_MESSAGE
    );
  }

  return Promise.reject(error);
};

axiosInstance.interceptors.response.use((response) => response, handleResponseError);

export default axiosInstance;